// src/Redux/UI/uiFeedbackSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  type: 'info',   // 'success' | 'error' | 'warning' | 'info'
  title: '',
  message: '',
  id: 0,          // bump to force re-auto-close timers
};

const uiFeedbackSlice = createSlice({
  name: 'uiFeedback',
  initialState,
  reducers: {
    showFeedback(state, action) {
      const { type = 'info', title = '', message = '' } = action.payload || {};
      state.open = true;
      state.type = type;
      state.title = title;
      state.message = message;
      state.id += 1;
    },
    hideFeedback(state) {
      state.open = false;
    },
    clearFeedback() {
      return initialState;
    },
  },
});

export const { showFeedback, hideFeedback, clearFeedback } = uiFeedbackSlice.actions;
export default uiFeedbackSlice.reducer;
